<template>
  <svg
    id="Heißluftballon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 153.8 236.4"
    preserveAspectRatio="xMinYMin"
  >
    <path
      style="fill: #616160;"
      d="M84.1,212.1c-0.2-1.9-0.6-3.9-1.6-5.5c-0.4-0.6-0.9-1.1-1.3-1.4c-0.3-0.3-0.7-0.4-1.1-0.4h-6.9
	c-0.4,0-0.8,0.1-1.1,0.4c-0.4,0.3-0.9,0.8-1.3,1.4c-1.1,1.6-1.4,3.6-1.6,5.5c-0.3,2.4-0.1,4.9,0.5,7.2c0.1,0.5,0.6,0.8,1,0.8
	c0.1,0,0.3,0,0.4-0.1c0.5-0.2,0.8-0.8,0.6-1.3c-0.3-1.3-0.5-2.7-0.6-4.1c0-0.8,0-1.3,0.1-2.4c0.1-1.2,0.4-2.9,1.2-4.9c0,0,0,0,0,0
	v7.9c0,0,0,0,0,0h8c0,0,0,0,0,0v-7.9c0,0,0,0,0,0c0.8,2,1.1,3.7,1.2,4.9c0.1,1.1,0.1,1.6,0.1,2.4c0,1.4-0.2,2.7-0.6,4.1
	c-0.1,0.5,0.1,1.1,0.6,1.3c0.1,0.1,0.3,0.1,0.4,0.1c0.5,0,0.9-0.3,1-0.8C84.2,217,84.4,214.5,84.1,212.1z"
    />
    <polygon
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      points="72.9,187 72.7,186.9 70.8,200
	71,200 "
    />
    <polygon
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      points="68.5,186.9 68.3,187 70.1,200
	70.4,200 "
    />
    <rect
      x="70.5"
      y="186.9"
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      width="0.2"
      height="13.1"
    />
    <rect
      x="82.8"
      y="186.9"
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      width="0.2"
      height="13.1"
    />
    <polygon
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      points="80.9,186.9 80.6,187 82.5,200
	82.7,200 "
    />
    <polygon
      style="
        fill: #c0c0c0;
        stroke: #c0c0c0;
        stroke-width: 0.4301;
        stroke-miterlimit: 10;
      "
      points="85.3,187 85.1,186.9 83.2,200
	83.4,200 "
    />
    <path
      style="fill: #1a304d;"
      d="M58.5,170.1c0.6,1.3,1.3,2.6,1.9,3.9c3.1,6.9,3.5,10.4,4.3,14.1l7.2,0.7c3.6,0.4,7.2,0.3,10.8,0
	l6.6-0.7c0.8-3.7,1.2-7.2,4.3-14.1c0.6-1.4,1.3-2.7,2-4C83.2,172.1,70.7,172.2,58.5,170.1z"
    />
    <path
      style="
        fill: none;
        stroke: #c0c0c0;
        stroke-width: 0.6129;
        stroke-miterlimit: 10;
      "
      d="M69.6,187.6"
    />
    <polygon style="fill: #c0c0c0;" points="82.8,200 82.7,200 82.8,200.6 " />
    <polygon style="fill: #c0c0c0;" points="70.8,200 70.7,200 70.7,200.6 " />
    <polygon style="fill: #c0c0c0;" points="70.5,200 70.4,200 70.5,200.6 " />
    <polygon style="fill: #c0c0c0;" points="83.2,200 83.1,200 83.1,200.6 " />
    <path
      style="fill: #c0c0c0;"
      d="M89.1,215l-3-15h-2.7h-0.2l-0.1,0.7V200h-0.2v0.7l-0.1-0.7h-0.2H71h-0.2l-0.1,0.7V200h-0.2v0.7
	l-0.1-0.7h-0.2h-2.5l-3,15c-0.1,0.3,0.2,0.7,0.5,0.8c0.3,0.1,0.7-0.2,0.8-0.5l2.8-14h1.7h0.5h11.9h0.5H85l2.8,14
	c0.1,0.3,0.3,0.5,0.6,0.5c0,0,0.1,0,0.1,0C88.9,215.7,89.2,215.4,89.1,215z"
    />
    <path
      style="fill: #bc7539;"
      d="M79.6,236.4h-5.5c-5.9,0-10.8-4.8-10.8-10.8v-10.1h27v10.1C90.3,231.6,85.5,236.4,79.6,236.4z"
    />
    <path
      style="fill: #1a304d;"
      d="M91.3,216H62.1c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h29.1c0.5,0,0.9,0.4,0.9,0.9
	C92.1,215.6,91.7,216,91.3,216z"
    />
    <path
      class="ballon-blau"
      d="M150.4,52.5c-0.7-2.3-1.6-4.6-2.6-6.9c-4.4-10.1-11-19-19.2-26.2c-4.6-4-9.6-7.5-15.1-10.4
	c-2.2-1.2-4.4-2.2-6.7-3.1c-3.5-1.4-7-2.6-10.7-3.5C90,0.8,83.6,0,76.9,0C34.4,0,0,33.5,0,74.8c0,7.5,1.1,14.7,3.2,21.5
	c2.7,8.8,7,16.9,12.6,23.9c5.1,7.1,11,12.7,17.1,18.5c2.3,2.2,4.7,4.4,7.1,6.8c0.9,0.9,1.9,1.9,2.8,2.9c2.3,2.5,4.6,5.1,6.8,8
	c3.1,4,6.1,8.5,8.8,13.8c6.1,1,12.3,1.5,18.5,1.5c6.2,0,12.4-0.6,18.5-1.6c1.9-3.7,4-7.1,6.1-10.2c0.9-1.2,1.7-2.4,2.6-3.6
	c1.8-2.3,3.6-4.4,5.4-6.4c0.5-0.5,0.9-1,1.4-1.5c3.7-3.9,7.5-7.5,11.3-11c0.5-0.4,0.9-0.9,1.4-1.3c0.9-0.9,1.8-1.8,2.8-2.7
	c3.2-3.1,6.3-6.4,9.1-9.9c0.8-1,1.6-2.1,2.4-3.2c0.6-0.8,1.2-1.6,1.8-2.4c2.4-3.2,4.5-6.7,6.3-10.3c0.5-0.9,0.9-1.8,1.3-2.7
	c2.5-5.5,4.3-11.4,5.4-17.5c0.7-4.1,1.1-8.3,1.1-12.6C153.8,67,152.6,59.6,150.4,52.5z"
    />
    <slot />

    <circle style="fill: #616160;" cx="76.7" cy="200.9" r="3.2" />
  </svg>
</template>

<script>
export default {
  name: 'AnBalloon'
};
</script>

<style lang="scss" scoped>
.ballon-blau {
  fill: $color-theme-blue;
}
</style>
